import { TenantOrderLine } from '~/lib/model';
import { Big } from 'big.js';
import TwtJob from '~/tenants/twt/model/TwtJob';
import { schema_latest_version, ZodVersionedMetadata } from '~/lib/zod';
import TwtSlideshowConfig from '~/tenants/twt/performable/slideshow/TwtSlideshowConfig';
import { DeliverableType } from '~common/model/Deliverable';
import { twt_version, TwtVersion } from '~/tenants/twt/data';
import TwtSocialVerticalConfig from '~/tenants/twt/performable/social-vertical/TwtSocialVerticalConfig';
import { TWT_SOCIAL_VERTICAL_PRICE } from '~/tenants/twt/performable/social-vertical/TwtSocialVerticalJob';

export class TwtSlideshowJob extends TwtJob<typeof TwtSlideshowConfig> {
  get performable(): typeof TwtSlideshowConfig {
    return TwtSlideshowConfig;
  }

  get deliverable(): DeliverableType {
    return DeliverableType.SLIDESHOW;
  }

  get short(): string {
    return 'SLIDE';
  }

  defaultValue(): ZodVersionedMetadata<(typeof TwtSlideshowConfig)['schema']> {
    return {
      version: schema_latest_version(TwtSlideshowConfig.schema),
    };
  }

  revenueLines(): TenantOrderLine[] {
    const lines = super.revenueLines();
    const price = new Big(!twt_version(this.order.created, TwtVersion.V4) ? 25 : 35);

    // An order that has the vertical social video already (TwtSocialVerticalJob,
    // from 14 Oct 2026) is upgraded: this includes that video, so it costs the
    // difference, and the two together are never more than this alone. No
    // order placed before that has the job, so none is repriced by it.
    const vertical =
      this.order.socialVerticalRefunded !== true &&
      this.order.jobs.some((job) => job.performable_id === TwtSocialVerticalConfig.id);

    lines.push({
      amount: vertical ? price.minus(TWT_SOCIAL_VERTICAL_PRICE) : price,
      taxable: true,
      description: vertical ? 'Video Slideshow (upgrade from the Vertical Social Video)' : 'Video Slideshow',
      id: 'slideshow',
      discountable: true,
    });

    return lines;
  }
}
